import { render, staticRenderFns } from "./form_input.vue?vue&type=template&id=0a09ccef&scoped=true&lang=pug"
import script from "./form_input.vue?vue&type=script&lang=js"
export * from "./form_input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a09ccef",
  null
  
)

export default component.exports